import { Box, Container, Typography } from '@mui/material';
import StepperProps from '../../lib/StepperProps';
import ClientOnboardingStepper from './ClientOnboardingStepper';

/**
 * A stepper component to use on wide screens
 */
const WideStepper = (props: StepperProps) => (
  <>
    <Box display="flex" height="100%">
      <ClientOnboardingStepper {...props} />
      <Box overflow="auto" width="100%" height="100%">
        <Container
          sx={{
            padding: '1em',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          {props.steps.length > 0 && props.showTitle && (
            <Typography
              component="h1"
              textAlign="center"
              fontSize="2.5em"
              fontWeight="600"
              gutterBottom
            >
              {props.steps[props.activeStep].stepTitle}
            </Typography>
          )}
          {props.steps.length > 0
            ? props.steps[props.activeStep].stepContent
            : ''}
        </Container>
      </Box>
    </Box>
  </>
);

export default WideStepper;
